import styled from "styled-components";

export const ServicesCitiesWrapper = styled.div`
    display: flex;
	width: 100%;
	background-color: var(--white);
    box-shadow: 0px 0px 5px rgba(0, 0, 0, .1);
    border-radius: 10px;
    padding: 24px;
    flex-wrap: wrap;
    @media (max-width: 767px) {
        padding: 0px 16px 16px 16px;
        box-shadow: none;
        border-radius: 0px;
        .citiesBtns{
            flex-wrap: wrap;
            button{
                width: fit-content;
                min-width: 100px;
            }
        }
    }
`